export default __webpack_public_path__ + "static/media/ufpe.468fe989.png";